import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=bead64c0&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=bead64c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bead64c0",
  null
  
)

export default component.exports